import type { CSSProperties } from "react";

export function BilliardBallIcon({
  number,
  size = 48,
  monochrome = false,
  style,
}: {
  number: 9 | 10;
  size?: number;
  monochrome?: boolean;
  style?: CSSProperties;
}) {
  const ballColor = monochrome
    ? "currentColor"
    : number === 10
      ? "#4b90d4"
      : "#efbe3f";

  return (
    <svg
      style={style}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <g
        stroke={ballColor}
        strokeWidth={monochrome ? 3.2 : 2}
        strokeLinecap="round"
      >
        <circle cx="32" cy="32" r="29" />
        <path d="M11 12h42M11 52h42" />
        <circle cx="32" cy="32" r="13.5" />
      </g>
      <text
        x={number === 10 ? 31.33 : 32}
        y="32"
        dy="0.35em"
        fill={monochrome ? "currentColor" : "#50585b"}
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="700"
        fontSize={number === 10 ? 18 : 23}
        letterSpacing={number === 10 ? "-0.8px" : undefined}
        textAnchor="middle"
      >
        {number}
      </text>
    </svg>
  );
}
